import ResizeObserver from 'resize-observer-polyfill'
import { throttle } from 'lodash'

export default {
  data () {
    return {
      scrollHeight: 0,
      scrollTop: 0,
      innerHeight: window.innerHeight
    }
  },
  computed: {
    scrollPercentage () {
      return Number(Math.min(((this.scrollTop + this.innerHeight) / this.scrollHeight) * 100, 100))
    }
  },
  mounted () {
    this.rootObserveSize()
    window.addEventListener('scroll', throttle(this.getScrollTop, 250))
  },
  methods: {
    getScrollTop () {
      this.scrollTop = window.pageYOffset
    },
    rootObserveSize () {
      const ro = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const { height } = entry.contentRect
          this.scrollHeight = height
          this.innerHeight = window.innerHeight
        })
      })
      ro.observe(this.$root.$el)
    }
  }
}
